import { AnimatePresence } from "motion/react";
import { Route, Routes } from "react-router-dom";

import { AccessControl } from "@ryde/controls";
import { NotificationEdit } from "@ryde/layout";

export const NotificationsRoutes = (): JSX.Element => (
  <AnimatePresence mode="wait">
    <Routes>
      <Route
        path="add"
        element={
          <AccessControl entity="notification" action="create">
            <NotificationEdit />
          </AccessControl>
        }
      ></Route>
      <Route
        path="add/:id"
        element={
          <AccessControl entity="notification" action="update">
            <NotificationEdit />
          </AccessControl>
        }
      ></Route>
      <Route
        path="edit/:id"
        element={
          <AccessControl entity="notification" action="read">
            <NotificationEdit />
          </AccessControl>
        }
      ></Route>
    </Routes>
  </AnimatePresence>
);
